import { Component, Input, ViewChild } from "@angular/core";
import { CBP7501 } from "../../../../objects/documents/CBP7501";
import { NgForm } from "@angular/forms";

@Component({
    selector: 'declaration-block-7501',
    templateUrl: 'declaration-block-7501.component.html',
    moduleId: module.id.toString()
})
export class DeclarationBlock7501Component {
    @Input()
    public document: CBP7501;

    @ViewChild('declarationForm') declarationForm: NgForm;

    public submitFormAndValidity(): boolean{
        this.declarationForm.onSubmit(null);

        return this.isFormValid();
    }

    public isFormValid(): boolean{
        return this.declarationForm.valid;
    }
}


// WEBPACK FOOTER //
// ./app/components/export-documents/cbp-7501/document-blocks/declaration-block-7501.component.ts